<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="任务标题" prop="taskTitle">
                <a-input v-model="queryParam.taskTitle" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'任务标题'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <template>

              <a-col :md="12" :sm="24">
                <a-form-item label="省市区" prop="region">
                  <a-cascader 
                    v-model="queryParam.regionCodes" 
                    :options="cityTreeOptions" 
                    :placeholder="$t('通用.输入.请输入')+'省/市/区'" 
                    :field-names="{ label: 'areaName', value: 'areaId', children: 'children' }"
                    allow-clear
                    @change="onRegionChange"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="曝光选择" prop="exposureOptions">
                  <a-select 
                    v-model="queryParam.exposureOptions" 
                    placeholder="请选择曝光选择" 
                    allow-clear
                    style="width: 100%"
                  >
                    <a-select-option 
                      v-for="item in enumOptions.exposureOptions" 
                      :key="item.code"
                      :value="item.code"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="任务类别" prop="taskCategory">
                  <a-select 
                    v-model="queryParam.taskCategory" 
                    :placeholder="$t('通用.输入.请输入')+'任务类别'" 
                    allow-clear
                    style="width: 100%"
                  >
                    <a-select-option 
                      v-for="item in enumOptions.orderTypes" 
                      :key="item.code"
                      :value="item.code"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="任务状态" prop="taskStatus">
                  <a-select 
                    v-model="queryParam.taskStatus" 
                    placeholder="请选择任务状态" 
                    allow-clear
                    style="width: 100%"
                  >
                    <a-select-option :value="0">下架</a-select-option>
                    <a-select-option :value="1">上架</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="审核状态" prop="auditStatus">
                  <a-select 
                    v-model="queryParam.auditStatus" 
                    placeholder="请选择审核状态" 
                    allow-clear
                    style="width: 100%"
                  >
                    <a-select-option :value="0">待审核</a-select-option>
                    <a-select-option :value="1">通过</a-select-option>
                    <a-select-option :value="2">拒绝</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="查看权限" prop="viewPermission">
                  <a-select 
                    v-model="queryParam.viewPermission" 
                    placeholder="请选择查看权限" 
                    allow-clear
                    style="width: 100%"
                  >
                    <a-select-option 
                      v-for="item in enumOptions.publishTypes" 
                      :key="item.code"
                      :value="item.code"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="预计到达时间(分钟)" prop="estimatedArrivalMinutes">
                  <a-select 
                    v-model="queryParam.estimatedArrivalMinutes" 
                    placeholder="请选择预计到达时间" 
                    allow-clear
                    style="width: 100%"
                  >
                    <a-select-option 
                      v-for="item in timeConfigOptions" 
                      :key="item.id" 
                      :value="item.configValue"
                    >
                      {{ item.configValue }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="是否预约单" prop="isAppointment">
                  <a-select 
                    v-model="queryParam.isAppointment" 
                    placeholder="请选择是否预约单" 
                    allow-clear
                    style="width: 100%"
                  >
                    <a-select-option :value="0">否</a-select-option>
                    <a-select-option :value="1">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
<!--              <a-col :md="6" :sm="24">-->
<!--                <a-form-item label="价格单位" prop="priceUnit">-->
<!--                  <a-input v-model="queryParam.priceUnit" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'价格单位，例如: 天/次/小时'" allow-clear @pressEnter="handleQuery"/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="6" :sm="24">-->
<!--                <a-form-item label="发布时间" prop="publishTime">-->
<!--                  <a-date-picker style="width: 100%" v-model="queryParam.publishTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="6" :sm="24">-->
<!--                <a-form-item label="创建时间" prop="createdAt">-->
<!--                  <a-date-picker style="width: 100%" v-model="queryParam.createdAt" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="6" :sm="24">-->
<!--                <a-form-item label="更新时间" prop="updatedAt">-->
<!--                  <a-date-picker style="width: 100%" v-model="queryParam.updatedAt" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
              <a-col :md="12" :sm="24">
                <a-form-item :label="$t('发布时间区间')" prop="publishTimeRange">
                  <a-range-picker 
                    style="width: 100%" 
                    v-model="queryParam.publishTimeRange"
                    :show-time="{defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]}"
                    format="YYYY-MM-DD HH:mm:ss"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons" style="float: right; overflow: hidden">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="multiple" @click="handleBatchAudit" v-hasPermi="['task:taskmain:edit']">
          <a-icon type="check-circle" />批量审核
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="handleBatchUp" v-hasPermi="['task:taskmain:edit']">
          <a-icon type="up" />批量上架
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleBatchDown" v-hasPermi="['task:taskmain:edit']">
          <a-icon type="down" />批量下架
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['task:taskmain:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['task:taskmain:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
        <a-button type="primary" @click="showShareRatioSetting" style="margin-left: 8px" v-hasPermi="['task:taskmain:edit']">
          <a-icon type="percentage" />设置邀请收益
        </a-button>

        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '100%' }"
      >
          <span slot="publishTime" slot-scope="text, record">
            {{ parseTime(record.publishTime) }}
          </span>
          <span slot="createdAt" slot-scope="text, record">
            {{ parseTime(record.createdAt) }}
          </span>
          <span slot="updatedAt" slot-scope="text, record">
            {{ parseTime(record.updatedAt) }}
          </span>
          <span slot="fullAddress" slot-scope="text, record">
          {{ [record.province, record.city, record.district, record.detailAddress].filter(Boolean).join('') }}
        </span>
        <span slot="identityTagsRender" slot-scope="text, record">
          {{ formatIdentityTags(text) }}
        </span>
        <span slot="taskStatus" slot-scope="text, record">
          {{ record.taskStatus === 0 ? '下架' : record.taskStatus === 1 ? '上架' : record.taskStatus }}
        </span>
        <span slot="auditStatus" slot-scope="text, record">
          {{ record.auditStatus === 0 ? '待审核' : record.auditStatus === 1 ? '通过' : record.auditStatus === 2 ? '拒绝' : record.auditStatus }}
        </span>
        <span slot="viewPermission" slot-scope="text, record">
          {{ getViewPermissionLabel(record.viewPermission) }}
        </span>
        <span slot="isAppointment" slot-scope="text, record">
          {{ record.isAppointment ? '是' : '否' }}
        </span>
        <span slot="exposureOptions" slot-scope="text, record">
          {{ getExposureOptionsLabel(record.exposureOptions) }}
        </span>
        <span slot="operation" slot-scope="text, record">
            <a v-if="record.auditStatus === 0" @click="handleAudit(record)" v-hasPermi="['task:taskmain:edit']">
              <a-icon type="check-circle" />审核
            </a>
            <a-divider type="vertical" v-hasPermi="['task:taskmain:edit']" />
            <a @click="handleToggleStatus(record)" v-hasPermi="['task:taskmain:edit']">
               <a-icon :type="record.taskStatus === 0 ? 'up' : 'down'" />{{record.taskStatus === 0 ? '上架' : '下架'}}
            </a>
            <a-divider type="vertical" v-hasPermi="['task:taskmain:remove']" />
            <a @click="handleDelete(record)" v-hasPermi="['task:taskmain:remove']">
              <a-icon type="delete" />{{$t('通用.按钮.删除')}}
            </a>
          </span>
        </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <!-- 分成比例设置弹窗 -->
    <a-modal
      title="设置邀请收益"
      :visible="shareRatioSettingVisible"
      @ok="saveShareRatioSetting"
      @cancel="shareRatioSettingCancel"
      okText="确定"
      cancelText="取消"
    >
      <a-form layout="vertical">
        <a-form-item label="邀请收益（%）">
          <a-input-number
            v-model="shareRatio"
            :min="1"
            :max="100"
            style="width: 100%"
            placeholder="请输入邀请收益"
          />
          <div style="color: #999; font-size: 12px; margin-top: 5px;">
            设置邀请收益比例，默认10%
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageTaskMain,listTaskMain, delTaskMain, getEnumOptions, auditTaskMain, updateTaskStatus, getShareRatioSetting, setShareRatioSetting } from '@/api/task/taskMain'
import { cityListTree } from '@/api/logistics'
import { listTaskTimeConfig } from '@/api/task/taskTimeConfig'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'TaskMain',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 城市树数据
      cityTreeOptions: [],
      // 时间配置选项
      timeConfigOptions: [],
      // 枚举选项数据
      enumOptions: {
        publishTypes: [],
        exposureOptions: [],
        orderTypes: []
      },
      // 分成比例设置弹窗
      shareRatioSettingVisible: false,
      shareRatio: 10, // 默认10%
      // 查询参数
      queryParam: {
        taskTitle: undefined,
        taskDesc: undefined,
        taskVideoUrl: undefined,
        taskVideoCover: undefined,
        voteCount: undefined,
        usedVoteCount: undefined,
        remainVoteCount: undefined,
        province: undefined,
        city: undefined,
        district: undefined,
        regionCodes: [],
        detailAddress: undefined,
        taskType: undefined,
        taskCategory: undefined,
        identityTags: undefined,
        viewPermission: undefined,
        exposureOptions: undefined,
        estimatedArrivalMinutes: undefined,
        priceUnit: undefined,
        taskStatus: undefined,
        auditStatus: undefined,
        isAppointment: undefined,
        publishTime: undefined,
        publishTimeRange: undefined,
        createdAt: undefined,
        updatedAt: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        
        {
          title: '发布用户',
          dataIndex: 'publisherName',
          ellipsis: true,
          width: '100px',
          align: 'center'
        },
        {
          title: '任务标题',
          dataIndex: 'taskTitle',
          ellipsis: true,
          width: '100px',
          align: 'center'
        },
        {
          title: '任务描述',
          dataIndex: 'taskDesc',
          ellipsis: true,
          width: '100px',
          align: 'center'
        },
        {
          title: '任务视频地址',
          dataIndex: 'taskVideoUrl',
          ellipsis: true,
          width: '100px',
          align: 'center'
        },
        {
          title: '视频封面图',
          dataIndex: 'taskVideoCover',
          ellipsis: true,
          width: '100px',
          align: 'center'
        },
        {
          title: '曝光选择',
          dataIndex: 'exposureOptions',
          ellipsis: true,
          width: '100px',
          align: 'center',
          scopedSlots: { customRender: 'exposureOptions' }
        },
        {
          title: '详细地址',
          dataIndex: 'fullAddress',
          ellipsis: true,
          width: '200px',
          align: 'center',
          scopedSlots: { customRender: 'fullAddress' }
        },
        {
          title: '任务类型',
          dataIndex: 'taskType',
          ellipsis: true,
          width: '100px',
          align: 'center'
        },
        {
          title: '任务类别',
          dataIndex: 'taskCategory',
          ellipsis: true,
          width: '100px',
          align: 'center'
        },
        {
          title: '身份标签',
          dataIndex: 'identityTags',
          ellipsis: true,
          width: '100px',
          align: 'center',
          scopedSlots: { customRender: 'identityTagsRender' }
        },
        {
          title: '查看权限',
          dataIndex: 'viewPermission',
          ellipsis: true,
          width: '100px',
          align: 'center',
          scopedSlots: { customRender: 'viewPermission' }
        },
        {
          title: '预计到达时间(分钟)',
          dataIndex: 'estimatedArrivalMinutes',
          ellipsis: true,
          width: '100px',
          align: 'center'
        },
        {
          title: '价格',
          dataIndex: 'taskPrice',
          ellipsis: true,
          width: '100px',
          align: 'center'
        },
        {
          title: '单位',
          dataIndex: 'priceUnit',
          ellipsis: true,
          width: '100px',
          align: 'center'
        },
        {
          title: '任务状态',
          dataIndex: 'taskStatus',
          ellipsis: true,
          width: '100px',
          align: 'center',
          scopedSlots: { customRender: 'taskStatus' }
        },
        {
          title: '审核状态',
          dataIndex: 'auditStatus',
          ellipsis: true,
          width: '100px',
          align: 'center',
          scopedSlots: { customRender: 'auditStatus' }
        },
        {
          title: '是否预约单',
          dataIndex: 'isAppointment',
          ellipsis: true,
          width: '100px',
          align: 'center',
          scopedSlots: { customRender: 'isAppointment' }
        },
        {
          title: '发布时间',
          dataIndex: 'publishTime',
          scopedSlots: { customRender: 'publishTime' },
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createdAt',
          scopedSlots: { customRender: 'createdAt' },
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updatedAt',
          scopedSlots: { customRender: 'updatedAt' },
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '220px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getCityTree()
    this.getEnumOptionsData()
    this.getTimeConfigOptions()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 获取查看权限显示值 */
    getViewPermissionLabel(code) {
      console.log(code)
      if (!this.enumOptions || !this.enumOptions.publishTypes) {
        return code
      }
      const item = this.enumOptions.publishTypes.find(item => String(item.code) === String(code))
      return item ? item.name : code
    },
    /** 获取曝光选择显示值 */
    getExposureOptionsLabel(code) {
      if (!this.enumOptions || !this.enumOptions.exposureOptions) {
        return code
      }
      const item = this.enumOptions.exposureOptions.find(item => String(item.code) === String(code))
      return item ? item.name : code
    },
    /** 格式化身份标签 */
    formatIdentityTags(text) {
      try {
        const tags = JSON.parse(text);
        if (Array.isArray(tags)) {
          return tags.map(tag => {
            const key = Object.keys(tag)[0];
            return `${key}:${tag[key]}`;
          }).join(', ');
        }
      } catch (e) {
        console.error("Error parsing identityTags:", e);
      }
      return text; // Return original text if parsing fails
    },
    /** 查询任务主信息列表 */
    getList () {
      this.loading = true
      // 处理时间区间，拆分成两个字段
      const params = { ...this.queryParam }
      if (params.publishTimeRange && params.publishTimeRange.length === 2) {
        params.publishBeginTime = params.publishTimeRange[0]
        params.publishEndTime = params.publishTimeRange[1]
      }
      delete params.publishTimeRange
      pageTaskMain(params).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        taskTitle: undefined,
        taskDesc: undefined,
        taskVideoUrl: undefined,
        taskVideoCover: undefined,
        voteCount: undefined,
        usedVoteCount: undefined,
        remainVoteCount: undefined,
        province: undefined,
        city: undefined,
        district: undefined,
        detailAddress: undefined,
        taskType: undefined,
        taskCategory: undefined,
        identityTags: undefined,
        viewPermission: undefined,
        exposureOptions: undefined,
        estimatedArrivalMinutes: undefined,
        priceUnit: undefined,
        taskStatus: undefined,
        auditStatus: undefined,
        isAppointment: undefined,
        publishTime: undefined,
        publishTimeRange: undefined,
        createdAt: undefined,
        updatedAt: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          return delTaskMain(that.ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 审核按钮操作 */
    handleAudit(row) {
      const that = this
      this.$confirm({
        title: '任务审核',
        content: '请确认审核通过该任务？',
        icon: null,
        okText: '审核通过',
        cancelText: '审核拒绝',

        onOk() {
          return auditTaskMain({
            ids: [row.id],
            auditStatus: 1,
            auditRemark: ''
          }).then(() => {
            that.getList()
            that.$message.success('审核通过成功')
          })
        },

        onCancel() {
          return auditTaskMain({
            ids: [row.id],
            auditStatus: 2,
            auditRemark: ''
          }).then(() => {
            that.getList()
            that.$message.success('审核拒绝成功')
          })
        }
      })
    },
    /** 上架/下架按钮操作 */
    handleToggleStatus (row) {
      var that = this
      const newStatus = row.taskStatus === 0 ? 1 : 0
      const actionText = newStatus === 1 ? '上架' : '下架'
      this.$confirm({
        title: '确认' + actionText,
        content: `确定要${actionText}该任务吗？`,
        onOk () {
          return updateTaskStatus({ id: row.id, taskStatus: newStatus })
            .then(() => {
              that.getList()
              that.$message.success(actionText + '成功', 3)
          })
        }
      })
    },
    /** 批量审核按钮操作 */
    handleBatchAudit () {
      var that = this
      this.$confirm({
        title: '确认批量审核',
        content: `确定要审核选中的 ${this.ids.length} 条任务吗？`,
        onOk () {
          return auditTaskMain({ ids: that.ids, auditStatus: 1, auditRemark: '' })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('批量审核成功', 3)
          })
        }
      })
    },
    /** 批量上架按钮操作 */
    handleBatchUp () {
      var that = this
      this.$confirm({
        title: '确认批量上架',
        content: `确定要上架选中的 ${this.ids.length} 条任务吗？`,
        onOk () {
          return updateTaskStatus({ ids: that.ids, taskStatus: 1 })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('批量上架成功', 3)
          })
        }
      })
    },
    /** 批量下架按钮操作 */
    handleBatchDown () {
      var that = this
      this.$confirm({
        title: '确认批量下架',
        content: `确定要下架选中的 ${this.ids.length} 条任务吗？`,
        onOk () {
          return updateTaskStatus({ ids: that.ids, taskStatus: 0 })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('批量下架成功', 3)
          })
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('task/task/main/export',
            that.queryParam
          , `任务主信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 获取城市树数据 */
    getCityTree() {
      console.log("123")
      cityListTree().then(response => {
        this.cityTreeOptions = response.data || []
      })
    },
    /** 获取枚举选项数据 */
    getEnumOptionsData() {
      getEnumOptions().then(response => {
        if (response.data) {
          this.enumOptions = response.data
          console.log('枚举选项数据:', this.enumOptions)
          console.log('orderTypes:', this.enumOptions.orderTypes)
        }
      }).catch(error => {
        console.error('获取枚举选项失败:', error)
      })
    },
    /** 获取时间配置选项 */
    getTimeConfigOptions() {
      listTaskTimeConfig({}).then(response => {
        if (response.data) {
          this.timeConfigOptions = response.data
          console.log('时间配置选项:', this.timeConfigOptions)
        }
      }).catch(error => {
        console.error('获取时间配置选项失败:', error)
      })
    },
    /** 弹出分成比例设置弹窗 */
    showShareRatioSetting() {
      this.shareRatioSettingVisible = true
      getShareRatioSetting().then(response => {
        if (response.code === '20001' && response.data) {
          this.shareRatio = response.data
        } else {
          this.shareRatio = 10 // 默认10%
        }
      })
    },
    /** 保存分成比例设置 */
    saveShareRatioSetting() {
      if (this.shareRatio <= 0 || this.shareRatio > 100) {
        this.$message.error('邀请收益比例必须在1-100之间')
        return
      }
      setShareRatioSetting({ ratio: this.shareRatio }).then(response => {
        if (response.code === '20001') {
          this.$message.success(`邀请收益比例已设置为 ${this.shareRatio}%`)
          this.shareRatioSettingVisible = false
        }
      })
    },
    /** 取消分成比例设置弹窗 */
    shareRatioSettingCancel() {
      this.shareRatioSettingVisible = false
    },
    /** 省市区选择变化 */
    onRegionChange(value, selectedOptions) {
      if (value && value.length > 0 && selectedOptions) {
        // 根据选中的层级设置省市区
        this.queryParam.province = selectedOptions[0] ? selectedOptions[0].areaName : undefined
        this.queryParam.city = selectedOptions[1] ? selectedOptions[1].areaName : undefined
        this.queryParam.district = selectedOptions[2] ? selectedOptions[2].areaName : undefined
      } else {
        this.queryParam.province = undefined
        this.queryParam.city = undefined
        this.queryParam.district = undefined
      }
    },
  }
}
</script>
